var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon32CircleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,11.599976,22.295014)",
    d: "M.67526 6.342423C.267906 6.71536-.364644 6.687458-.73758 6.280104-1.110515 5.87275-1.082614 5.240201-.67526 4.867264L.67526 6.342423ZM3.75428 2.16777 3.07902 1.430191C3.29529 1.232194 3.587561 1.139091 3.878506 1.175516 4.169451 1.211942 4.429749 1.374224 4.590533 1.619427L3.75428 2.16777ZM9.836253 9.619427C10.139095 10.081277 10.010194 10.701181 9.548344 11.004024 9.086493 11.306866 8.466589 11.177964 8.163747 10.716114L9.836253 9.619427ZM-.67526 4.867264 3.07902 1.430191 4.42954 2.90535 .67526 6.342423-.67526 4.867264ZM4.590533 1.619427 9.836253 9.619427 8.163747 10.716114 2.918026 2.716114 4.590533 1.619427Z",
    fill: "#0a7e85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,4,30)",
    d: "M12 1C19.179703 1 25 6.820297 25 14H23C23 7.924868 18.075133 3 12 3V1ZM25 14C25 21.179703 19.179703 27 12 27V25C18.075133 25 23 20.075133 23 14H25ZM12 27C4.820298 27-1 21.179703-1 14H1C1 20.075133 5.924868 25 12 25V27ZM-1 14C-1 6.820297 4.820298 1 12 1V3C5.924868 3 1 7.924868 1 14H-1Z",
    fill: "#0a7e85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon32CircleCheck);
export default __webpack_public_path__ + "static/media/icon32_circle_check.0db9a742339cd9e63322cd08c4b86404.svg";
export { ForwardRef as ReactComponent };